import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import useNotificationListFilterActions from '../../use-notification-list-filters-store/hooks/use-filter-actions';
import { useNotificationActions } from '../../use-notification-list-store/store';
var useResetStores = function useResetStores() {
  var _useNotificationActio = useNotificationActions(),
    _useNotificationActio2 = _slicedToArray(_useNotificationActio, 2),
    resetNotificationListStore = _useNotificationActio2[1].resetNotificationListStore;
  var _useNotificationListF = useNotificationListFilterActions(),
    resetNotificationListFiltersStore = _useNotificationListF.resetNotificationListFiltersStore;
  return useCallback(function (categoryFilters, productFilters) {
    resetNotificationListFiltersStore(categoryFilters, productFilters);
    resetNotificationListStore();
  }, [resetNotificationListFiltersStore, resetNotificationListStore]);
};
export default useResetStores;